import Http from '@/services/http';

const urls = {
  base: '/versionamento/listar',
};

export default {
  getVersions() {
    const http = new Http();
    return http.get(urls.base)
      .then(response => response.data);
  },
};
